// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__m444X","Star1Icon":"Button_Star1Icon__lCMTu","Star2Icon":"Button_Star2Icon__LfzsH","Star3Icon":"Button_Star3Icon__ApGpz"};